import { UiProgramType } from '../enum/ui-utils.enum';
import {
    CourseActionType,
    CourseType,
    FilterType,
    ProgramLanguage,
    ProgramType,
    WebinarType,
} from '../enum/webinar-course.enum';
import { RecursiveMatSelectInterface } from '../models/filter.model';
import {
    EnumOptionInterface,
    EnumOptionProperties,
    UiProgramTypeInterface,
    UiProgramTypeProperties,
} from '../models/ui.model';
import { MINUTES } from './app.constant';

export const COURSE_ACTION_TYPES: EnumOptionInterface = {
    [CourseActionType.ResumeLearning]: { label: 'enum.courseActionType.resumeLearning', cssClass: '' },
    [CourseActionType.WatchNow]: { label: 'enum.courseActionType.watchNow', cssClass: '' },
};

export const COURSE_TYPE: EnumOptionInterface = {
    [CourseType.IncomeTax]: { label: 'enum.courseType.incomeTax', cssClass: '' },
};

export function getCourseType(option: CourseType): EnumOptionProperties {
    return COURSE_TYPE[option] || new EnumOptionProperties();
}

export const COURSE_CHIPS_ITEMS = [
    { controlName: 'english', title: 'courseListing.english' },
    { controlName: 'mandarin', title: 'courseListing.mandarin' },
    { controlName: 'webinar', title: 'courseListing.webinar' },
    { controlName: 'live', title: 'courseListing.live' },
    { controlName: 'recorded', title: 'courseListing.past' },
    { controlName: 'courses', title: 'courseListing.courses' },
    { controlName: 'eInvoicing', title: 'courseListing.eInvoicing' },
    { controlName: 'eInvoicing2024', title: 'courseListing.eInvoicing2024' },
    { controlName: 'eInvoicing2023', title: 'courseListing.eInvoicing2023' },
    { controlName: 'updateClasses', title: 'courseListing.updateClasses' },
    { controlName: 'updateClasses2024', title: 'courseListing.updateClasses2024' },
    { controlName: 'updateClasses2023', title: 'courseListing.updateClasses2023' },
    { controlName: 'other', title: 'courseListing.other' },
    { controlName: 'other2024', title: 'courseListing.other2024' },
    { controlName: 'other2023', title: 'courseListing.other2023' },
    { controlName: 'incomeTax', title: 'courseListing.incomeTax' },
    { controlName: 'income', title: 'courseListing.income' },
    { controlName: 'expenses', title: 'courseListing.expenses' },
    { controlName: 'withholdingTax', title: 'courseListing.withholdingTax' },
    { controlName: 'others', title: 'courseListing.others' },
    { controlName: 'sst', title: 'courseListing.sst' },
    { controlName: 'serviceTax', title: 'courseListing.serviceTax' },
    { controlName: 'salesTax', title: 'courseListing.salesTax' },
    { controlName: 'forms', title: 'courseListing.forms' },
    { controlName: 'formEAndEA', title: 'courseListing.formEAndEA' },
    { controlName: 'formBE', title: 'courseListing.formBE' },
    { controlName: 'formCP204', title: 'courseListing.formCP204' },
    { controlName: 'formB', title: 'courseListing.formB' },
    { controlName: 'formC', title: 'courseListing.formC' },
    { controlName: 'formCP22', title: 'courseListing.formCP22' },
];

export const TOPIC_FILTER_LIST = [
    {
        controlName: 'eInvoicing',
        title: 'courseListing.eInvoicing',
        isExpand: false,
        children: [
            { controlName: 'eInvoicing2024', title: 'courseListing.2024' },
            { controlName: 'eInvoicing2023', title: 'courseListing.2023' },
        ],
    },
    {
        controlName: 'updateClasses',
        title: 'courseListing.updateClasses',
        isExpand: false,
        children: [
            { controlName: 'updateClasses2024', title: 'courseListing.2024' },
            { controlName: 'updateClasses2023', title: 'courseListing.2023' },
        ],
    },
    {
        controlName: 'other',
        title: 'courseListing.other',
        isExpand: false,
        children: [
            { controlName: 'other2024', title: 'courseListing.2024' },
            { controlName: 'other2023', title: 'courseListing.2023' },
        ],
    },
    {
        controlName: 'incomeTax',
        title: 'courseListing.incomeTax',
        isExpand: false,
        children: [
            { controlName: 'income', title: 'courseListing.income' },
            { controlName: 'expenses', title: 'courseListing.expenses' },
            { controlName: 'withholdingTax', title: 'courseListing.withholdingTax' },
            { controlName: 'others', title: 'courseListing.others' },
        ],
    },
    {
        controlName: 'sst',
        title: 'courseListing.sst',
        isExpand: false,
        children: [
            { controlName: 'serviceTax', title: 'courseListing.serviceTax' },
            { controlName: 'salesTax', title: 'courseListing.salesTax' },
        ],
    },
    {
        controlName: 'forms',
        title: 'courseListing.forms',
        isExpand: false,
        children: [
            { controlName: 'formEAndEA', title: 'courseListing.formEAndEA' },
            { controlName: 'formBE', title: 'courseListing.formBE' },
            { controlName: 'formCP204', title: 'courseListing.formCP204' },
            { controlName: 'formB', title: 'courseListing.formB' },
            { controlName: 'formC', title: 'courseListing.formC' },
            { controlName: 'formCP22', title: 'courseListing.formCP22' },
        ],
    },
];

export const UI_PROGRAM_TAG: UiProgramTypeInterface = {
    [UiProgramType.Course]: {
        label: 'enum.uiProgramType.course',
        backgroundColor: 'bg-[#4B3CA6]',
        vectorCss: 'border-r-yellow-[#3C3082] border-t-[#3C3082]',
    },
    [UiProgramType.LiveWebinar]: {
        label: 'enum.uiProgramType.liveWebinar',
        backgroundColor: 'bg-[#FF7B4C]',
        vectorCss: 'border-r-[#B48308] border-t-[#B48308]',
    },
    [UiProgramType.RecordedWebinar]: {
        label: 'enum.uiProgramType.recordedWebinar',
        backgroundColor: 'bg-[#004B65]',
        vectorCss: 'border-r-[#025F7F] border-t-[#025F7F]',
    },
    [UiProgramType.Podcast]: {
        label: 'enum.uiProgramType.podcast',
        backgroundColor: 'bg-[#DB3683]',
        vectorCss: 'border-r-[#B02A6B] border-t-[#B02A6B]',
    },
};

export function getUiProgramTag(option: UiProgramType): UiProgramTypeProperties {
    return UI_PROGRAM_TAG[option] || new UiProgramTypeProperties();
}

export const LANGUAGE_FILTER_OPTION: RecursiveMatSelectInterface[] = [
    {
        id: ProgramLanguage.English.toString(),
        name: 'enum.programLanguage.english',
        selected: false,
        expanded: false,
        filterType: FilterType.Language,
        children: [],
    },
    {
        id: ProgramLanguage.Mandarin.toString(),
        name: 'enum.programLanguage.mandarin',
        selected: false,
        expanded: false,
        filterType: FilterType.Language,
        children: [],
    },
];

export const COURSE_FILTER_OPTION: RecursiveMatSelectInterface[] = [
    {
        id: ProgramType.Webinar.toString(),
        name: 'enum.programType.webinar',
        selected: false,
        expanded: false,
        filterType: FilterType.ProgramType,
        children: [
            {
                id: WebinarType.Live.toString(),
                name: 'enum.webinarType.live',
                selected: false,
                expanded: false,
                filterType: FilterType.WebinarType,
                children: [],
            },
            {
                id: WebinarType.Recorded.toString(),
                name: 'enum.webinarType.recorded',
                selected: false,
                expanded: false,
                filterType: FilterType.WebinarType,
                children: [],
            },
        ],
    },
    {
        id: ProgramType.Course.toString(),
        name: 'enum.programType.course',
        selected: false,
        expanded: false,
        filterType: FilterType.ProgramType,
        children: [],
    },
    {
        id: ProgramType.Podcast.toString(),
        name: 'enum.programType.podcast',
        selected: false,
        expanded: false,
        filterType: FilterType.ProgramType,
        children: [],
    },
];

export const MINUTES_BEFORE_WEBINAR_START = 15 * MINUTES;
